import {baseRequest} from './base';

//列表
function list(params){
  let tempUrl = '/api/bureau/website/banner/getBureauBanner';
  return baseRequest(tempUrl,'get',params);
}

//新增
function add(params){
  let tempUrl = '/api/bureau/website/banner/saveBanner';
  return baseRequest(tempUrl,'post',params);
}

//删除
function del(params){
  let tempUrl = '/api/bureau/website/banner/del/'+params.id;
  return baseRequest(tempUrl,'delete');
}

//详情
function detail(params){
  let tempUrl = '/api/bureau/website/banner/getDetail/'+params.id;
  return baseRequest(tempUrl,'get',params);
}

export default {
  list,add,del,detail
}
